<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :items="items"
    item-text="name"
    item-value="value"
    v-bind="$attrs"
    v-on="$listeners"
    clearable
  )
</template>

<script>
import listsService from '@/services/API/lists';

export default {
  props: {
    value: { type: [Number, Array, Object, String], default: null },
    label: { type: String, default: 'Тип вебинара' },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    loadItems() {
      listsService.webinarScheduleTypes().then((response) => {
        this.items = response.data.data;
      });
    },
  },
};
</script>
